import {User} from '../interfaces/User';
import {API_BASE_URL} from './Settings';

export async function fetchUsers(): Promise<User[]> {
    const response = await fetch(`${API_BASE_URL}/users`);
    if (!response.ok) {
        throw new Error(`Erreur API: ${response.status}`);
    }
    return await response.json();
}

export async function fetchUser(id: number): Promise<User> {
    const response = await fetch(`${API_BASE_URL}/users/${id}`);
    if (!response.ok) {
        throw new Error(`Erreur API: ${response.status}`);
    }
    return await response.json();
}

export async function createUser(data: Partial<User> & { role: string }): Promise<User> {
    const response = await fetch(`${API_BASE_URL}/users`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        throw new Error(`Erreur API: ${response.status}`);
    }
    return await response.json();
}
